export enum UserCurveCategory {
  'customer_price_forecast' = 'customer_price_forecast',
  'customer_volume_forecast' = 'customer_volume_forecast',
  'nomination' = 'nomination',
  'declared' = 'declared',
  'manual_price' = 'manual_price',
  'network_allocation' = 'network_allocation',
}
